module.exports = __webpack_public_path__ + "img/rightarrow.8acc412f.svg";